/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { PieChartProps } from '../../PieChart.props';

export const getPieChartGeneralOptions = ({
  title,
  subtitle,
  dataLabelFormatter,
  disableTooltip,
  connectorColor,
  connectorWidth,
  staticChart,
  headerPosition,
}: PieChartProps): Highcharts.Options => {
  return {
    chart: {
      type: 'pie',
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        borderRadius: 6,
        dataLabels: {
          ...(connectorColor && { connectorColor }),
          ...(connectorWidth && { connectorWidth }),
          ...(dataLabelFormatter && {
            formatter: function formatDataLabels(): string {
              return dataLabelFormatter(this);
            },
          }),
          connectorPadding: 3,
          distance: 25,
          enabled: true,
          style: {
            fontSize: '14px',
          },
        },
        slicedOffset: staticChart ? 0 : 5,
      },
      series: {
        borderWidth: 3,
        className: 'pie-chart-slice',
        ...(staticChart && {
          marker: {
            states: {
              hover: {
                enabled: false,
              },
            },
          },
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1,
            },
          },
        }),
      },
    },
    subtitle: {
      align: headerPosition ?? 'center',
      text: subtitle,
      useHTML: true,
    },
    title: {
      align: headerPosition ?? 'center',
      text: title,
      useHTML: true,
    },
    tooltip: {
      enabled: disableTooltip ? false : true,
    },
  };
};
